import * as downloadQueueActions from 'spa/action_creators/download_queue'
import * as tagActions from 'spa/action_creators/tags'
import * as tracksActions from 'spa/action_creators/tracks'
import {
  activeSubscriptionSelector,
  desktopClientDownloadedSelector,
  loggedInSelector,
} from 'spa/selectors/users'
import { AVAILABLE_FEATURES, isFeatureEnabled } from '../../selectors/features'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { DEFAULT_KEY_INFORMATION, MAX_DOWNLOAD_COUNT } from 'spa/shared/utils'
import { DownloadAllTracksButton } from 'spa/components/track_buttons/download_all_tracks_button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { Link } from 'spa/components/link'
import { linkifyArtistNames, makeSongUrl } from 'spa/urls'
import { PlayTrackButton } from 'spa/components/track_buttons/play_track_button'
import { Popover } from 'spa/components/popover'
import { PreviewQueueButton } from 'spa/components/preview_queue_button'
import { queuedSongsSelector } from '../../selectors/songs'
import { SendAllTracksToDownloaderButton } from '../track_buttons/send_all_tracks_to_downloader_button/send_all_tracks_to_downloader_button'
import { SongPropType } from 'spa/api/songs'
import { TextStyle } from 'spa/components/typography'
import { TrackDropDownTableInfo } from 'spa/components/track_dropdown_table'
import { TRACKLIST } from '../../shared/constants'
import { TrackList, TrackListItem } from 'spa/components/track_list'
import { TrackListItemAll } from '../track_list/track_list_item_all'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

export class SimpleSongsListItem2 extends React.PureComponent {
  static propTypes = {
    activeSubscription: PropTypes.bool,
    addSongToQueue: PropTypes.func,
    batchDownload: PropTypes.func.isRequired,
    currentlyInQueue: PropTypes.bool,
    desktopClientDownloaded: PropTypes.bool,
    fetchTags: PropTypes.func,
    index: PropTypes.number,
    isLoadingTags: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    isMobile: PropTypes.bool,
    listIndex: PropTypes.number,
    queuedSongIds: PropTypes.any,
    removeSongFromQueue: PropTypes.func,
    sendAllTracksToDownloader: PropTypes.func.isRequired,
    separator: PropTypes.bool,
    showBulkDownload: PropTypes.bool.isRequired,
    showVersionsList: PropTypes.bool,
    song: SongPropType,
    tags: PropTypes.array.isRequired,
    toggleVersionsList: PropTypes.func,
    trackList: PropTypes.string,
    variant: PropTypes.oneOf(['light', 'dark']),
  }

  componentDidMount() {
    const { fetchTags, tags, isLoadingTags } = this.props

    if (!tags && !isLoadingTags) {
      fetchTags()
    }
  }

  onClickQueue = () => {
    const {
      song,
      queuedSongIds,
      addSongToQueue,
      removeSongFromQueue,
      trackList,
    } = this.props
    if (!song) {
      return
    }
    if (queuedSongIds.includes(parseInt(song.rid, 10))) {
      removeSongFromQueue(song)
    } else {
      addSongToQueue(song, trackList)
    }
  }

  isSomeVersionDownloaded = () => {
    const { song } = this.props
    return song.types.some(track => track.downloadCount > 0)
  }

  isBulkDownloadDisabledState = () => {
    const { song } = this.props
    return song.types.some(track => track.downloadCount >= MAX_DOWNLOAD_COUNT)
  }

  isBulkDownloadLoadingState = () => {
    const { song } = this.props
    return song.types.some(track => track.isDownloading)
  }

  handleDownloadAllClick = () => {
    const {
      sendAllTracksToDownloader,
      batchDownload,
      showBulkDownload,
      isMobile,
      song,
      trackList,
    } = this.props
    if (isMobile || !showBulkDownload) {
      sendAllTracksToDownloader({ songId: song.rid, trackList })
    } else if (showBulkDownload) {
      batchDownload({ songId: song.rid, trackList })
    }
  }

  render() {
    const {
      index,
      listIndex,
      song,
      currentlyInQueue,
      variant = 'dark',
      trackList,
      tags,
      showBulkDownload,
      isMobile,
      desktopClientDownloaded,
      activeSubscription,
      separator = true,
      showVersionsList,
      toggleVersionsList,
      isLoggedIn,
    } = this.props

    const tag = tags?.find(tag => tag.name === song.category)

    return !isMobile ? (
      <>
        <div className={classNames(styles.info)}>
          {/* Play button */}
          <PlayTrackButton
            className={styles.playButton}
            listIndex={listIndex}
            numberIndex={index}
            songId={song.rid}
            trackList={trackList}
          />
          {/* Title and Artist */}
          <div className={styles.titleAndArtist}>
            <Link to={makeSongUrl(song)}>
              <TextStyle
                className={styles.cellTitle}
                color={variant === 'dark' ? 'black' : 'white'}
                truncate
                variant="bold"
              >
                {song.title}
              </TextStyle>
            </Link>
            <TextStyle
              className={classNames('artist-names', styles.artist)}
              color={variant === 'dark' ? 'black' : 'white'}
              tagName="p"
              truncate
            >
              {linkifyArtistNames(song)}
            </TextStyle>
          </div>

          {/* Category */}
          <div className={styles.category}>
            <Link to={`/genre/${tag?.slug}`}>{song.category}</Link>
          </div>

          {/* BPM */}
          <div className={styles.category}>
            <TextStyle>{song.bpm}</TextStyle>
          </div>

          {/* Popularity */}
          <div className={styles.popularityContainer}>
            <div className={styles.popularityProgress}>
              <div
                className={styles.progress}
                style={{
                  width: `${
                    trackList === TRACKLIST.RELATED
                      ? song.popularity
                      : song.downloadCountPopularity
                  }%`,
                }}
              />
              <TextStyle className={styles.percentage}> </TextStyle>
            </div>
          </div>

          {/* Versions */}
          <div className={styles.versions}>
            <button
              className={classNames('cleanButton')}
              onClick={toggleVersionsList}
            >
              <FontAwesomeIcon icon={showVersionsList ? 'minus' : 'plus'} />
              <FormattedMessage
                defaultMessage="All versions"
                id="djcity.records.queue.track.all_tracks.title"
              />{' '}
              ({song.types.length})
              {this.isSomeVersionDownloaded() && (
                <FontAwesomeIcon color="red" icon="check" />
              )}
            </button>
          </div>

          {/* Download */}
          <div className={styles.mainDownload}>
            {!showBulkDownload ? (
              <button
                className={classNames({
                  inactive: !(desktopClientDownloaded && activeSubscription),
                })}
                onClick={this.handleDownloadAllClick}
              >
                <SendAllTracksToDownloaderButton
                  className={styles.desktopdownloader}
                />
                <FormattedHTMLMessage
                  defaultMessage="Send all to desktop app"
                  id="djcity.common.versions.desktop_all"
                />
              </button>
            ) : (
              <button
                className={classNames({
                  inactive: this.isBulkDownloadDisabledState(),
                })}
                onClick={this.handleDownloadAllClick}
              >
                {this.isBulkDownloadLoadingState() ? (
                  <FontAwesomeIcon icon="circle-notch" spin />
                ) : (
                  <DownloadAllTracksButton />
                )}
                <FormattedHTMLMessage
                  defaultMessage="Download all"
                  id="djcity.common.versions.download_all"
                />
              </button>
            )}
          </div>
        </div>

        {/* All versions menu */}

        {showVersionsList && (
          <div className={styles.info}>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td colSpan={2}>
              <TrackList>
                <TrackListItemAll
                  bold
                  className={[
                    styles.trackListItemDetails,
                    styles.trackListItemDetailsAll,
                  ]}
                  fileDate={song.fileDate}
                  songId={song.rid}
                  trackList={trackList}
                  tracks={song.types}
                />
                {song.types.map(track => {
                  return (
                    <TrackListItem
                      bold
                      className={styles.trackListItemDetails}
                      fileDate={track.fileDate}
                      key={track.tid}
                      songId={song.rid}
                      trackId={track.tid}
                      trackList={trackList}
                    />
                  )
                })}
              </TrackList>
            </td>
          </div>
        )}
        {separator && (
          <div className={styles.info}>
            <td className={styles.separator} colSpan="9" />
          </div>
        )}
      </>
    ) : (
      <>
        <div className={classNames(styles.info)}>
          {/* Play button */}
          <PlayTrackButton
            className={styles.playButton}
            listIndex={listIndex}
            numberIndex={index}
            songId={song.rid}
            trackList={trackList}
          />
          {/* Title and Artist */}
          <div className={styles.titleAndArtist}>
            <Link to={makeSongUrl(song)}>
              <TextStyle
                className={styles.cellTitle}
                color={variant === 'dark' ? 'black' : 'white'}
                truncate
                variant="bold"
              >
                {song.title}
              </TextStyle>
            </Link>
            <TextStyle
              className={classNames('artist-names', styles.artist)}
              color={variant === 'dark' ? 'black' : 'white'}
              tagName="p"
              truncate
            >
              {linkifyArtistNames(song)}
            </TextStyle>
          </div>

          <div className={styles.moreMenuButton}>
            <button
              className={classNames('cleanButton')}
              onClick={toggleVersionsList}
            >
              <FontAwesomeIcon
                icon={showVersionsList ? 'ellipsis-v' : 'ellipsis-h'}
              />
            </button>
          </div>
        </div>

        <div className={styles.info}>
          <div></div>

          {/* Popularity */}
          <div className={styles.popularityContainer}>
            <div className={styles.popularityProgress}>
              <div
                className={styles.progress}
                style={{
                  width: `${
                    trackList === TRACKLIST.RELATED
                      ? song.popularity
                      : song.downloadCountPopularity
                  }%`,
                }}
              />
              <TextStyle className={styles.percentage}> </TextStyle>
            </div>
          </div>

          <div></div>
        </div>

        {/* All versions menu */}
        {showVersionsList && (
          <div className={styles.info}>
            <td />
            <td>
              <div className={styles.infoBlock}>
                {/* Remixer */}
                {song.remixer && (
                  <div>
                    <TextStyle variant="extra-bold">
                      <FormattedMessage
                        defaultMessage="Remixer"
                        id="djcity.records.recordpool.track.remixer"
                      />
                    </TextStyle>
                    <div className={styles.category}>
                      <Link to={`/remixer/${song.remixer.slug}`}>
                        {song.remixer.name}
                      </Link>
                    </div>
                  </div>
                )}

                {/* BPM */}
                <div>
                  <TextStyle variant="extra-bold">
                    <FormattedMessage
                      defaultMessage="BPM"
                      id="djcity.records.recordpool.track.bpm"
                    />
                  </TextStyle>
                  <div className={styles.category}>
                    <TextStyle>{song.bpm}</TextStyle>
                  </div>
                </div>

                {/* Key */}
                {song.key !== DEFAULT_KEY_INFORMATION && (
                  <div>
                    <TextStyle variant="extra-bold">
                      <FormattedMessage
                        defaultMessage="Key"
                        id="djcity.records.recordpool.track.key"
                      />
                    </TextStyle>
                    <div className={styles.category}>
                      <TextStyle>{song.key}</TextStyle>
                    </div>
                  </div>
                )}

                {/* Category */}
                <div>
                  <TextStyle variant="extra-bold">
                    <FormattedMessage
                      defaultMessage="Genre"
                      id="djcity.records.recordpool.track.genre"
                    />
                  </TextStyle>
                  <div className={styles.category}>
                    <Link to={`/genre/${tag?.slug}`}>{song.category}</Link>
                  </div>
                </div>
              </div>
              <div className={styles.separator}></div>
              <div className={styles.versionsTitleContainer}>
                <Popover
                  closeOnScroll={false}
                  renderTrigger={({ handleClick, ref }) => (
                    <button
                      className={classNames(
                        'cleanButton',
                        styles.versionButton
                      )}
                      onClick={handleClick}
                      ref={ref}
                    >
                      <FontAwesomeIcon
                        className={styles.versionsTitle}
                        icon="info-circle"
                      />
                      <TextStyle
                        className={styles.versionsTitle}
                        variant="extra-bold"
                      >
                        <FormattedMessage
                          defaultMessage="Versions"
                          id="djcity.records.recordpool.track.versions"
                        />
                      </TextStyle>
                    </button>
                  )}
                  variant="light"
                >
                  <TrackDropDownTableInfo />
                </Popover>
              </div>
              <TrackList>
                <TrackListItemAll
                  bold
                  className={[
                    styles.trackListItemDetails,
                    styles.trackListItemDetailsAll,
                  ]}
                  showFileDate={false}
                  showTrackLength={false}
                  songId={song.rid}
                  trackList={trackList}
                  tracks={song.types}
                />
                {song.types.map(track => {
                  return (
                    <TrackListItem
                      bold
                      className={styles.trackListItemDetails}
                      key={track.tid}
                      showFileDate={false}
                      showTrackLength={false}
                      songId={song.rid}
                      trackId={track.tid}
                      trackList={trackList}
                    />
                  )
                })}
              </TrackList>

              {/* Download */}
              <div className={styles.mainDownload}>
                <button
                  className={classNames({
                    inactive: !(desktopClientDownloaded && activeSubscription),
                  })}
                  onClick={this.handleDownloadAllClick}
                >
                  <SendAllTracksToDownloaderButton
                    className={styles.desktopdownloader}
                  />
                  <FormattedHTMLMessage
                    defaultMessage="Send all to desktop app"
                    id="djcity.common.versions.desktop_all"
                  />
                </button>
              </div>

              {/* Preview */}
              {isLoggedIn && (
                <div className={styles.preview}>
                  <PreviewQueueButton
                    className={styles.queueButton}
                    currentlyInQueue={currentlyInQueue}
                    onClick={this.onClickQueue}
                  />
                </div>
              )}
            </td>
            <td />
          </div>
        )}
        {separator && (
          <div className={styles.info}>
            <td className={styles.separator} colSpan="9" />
          </div>
        )}
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    tags: state.tags.tags,
    isLoadingTags: state.tags.isLoading,
    isMobile: isMobileSelector(state),
    showBulkDownload: isFeatureEnabled(
      state.features,
      AVAILABLE_FEATURES.BULK_DOWNLOAD
    ),
    desktopClientDownloaded: desktopClientDownloadedSelector(state),
    activeSubscription: activeSubscriptionSelector(state),
    queuedSongIds: queuedSongsSelector(state).map(song => song.rid),
    isLoggedIn: loggedInSelector(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTags: bindActionCreators(tagActions, dispatch)?.fetchTags,
    batchDownload: bindActionCreators(tracksActions, dispatch)?.batchDownload,
    sendAllTracksToDownloader: bindActionCreators(
      downloadQueueActions,
      dispatch
    )?.sendAllTracksToDownloader,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimpleSongsListItem2)
